import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { PageErrorState } from '@components/core-ui/PageErrorState';

import { auditActorTypes } from '../../helpers/auditActorTypes';
import { auditBusinessActions } from '../../helpers/auditBusinessActions';
import { usePageContext } from '../../providers/PageProvider';
import { DiffDrawer } from './components/DiffDrawer';
import { Filters } from './components/Filters';
import { Header } from './components/Header';
import { Table } from './components/Table';

export const Content = () => {
  const {
    auditLogs,
    entityTypes,
    isLoading,
    hasError,
    filters,
    setFilter,
    setListFilter,
    setCreatedRange,
    clearFilters,
    hasActiveFilters,
    selectedAuditLog,
    selectAuditLog,
    sortingField,
    sortingReverse,
    toggleSort,
    page,
    setPage,
    pageSize,
    setPageSize,
  } = usePageContext();

  return (
    <>
      <Header />

      <LinearProgressLoader active={isLoading} />

      <main className="min-h-[calc(100vh-120px)] px-[30px] pb-[70px] pt-2">
        <Filters
          entityType={filters.entityType}
          entityId={filters.entityId}
          actorType={filters.actorType}
          businessAction={filters.businessAction}
          actorUserId={filters.actorUserId}
          actorLabel={filters.actorLabel}
          createdFrom={filters.createdFrom}
          createdTo={filters.createdTo}
          entityTypeOptions={entityTypes}
          actorTypeOptions={[...auditActorTypes]}
          businessActionOptions={auditBusinessActions}
          hasActiveFilters={hasActiveFilters}
          onCreatedRangeChange={setCreatedRange}
          onChange={setFilter}
          onListChange={setListFilter}
          onClear={clearFilters}
        />

        {hasError ? (
          <PageErrorState message="The audit log could not be loaded." />
        ) : (
          <Table
            auditLogs={auditLogs.data}
            totalItemsCount={auditLogs.count}
            isLoading={isLoading}
            sorting={{ field: sortingField, reverse: sortingReverse, toggle: toggleSort }}
            page={page}
            onPageChange={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            selectedAuditLogId={selectedAuditLog?.id}
            onRowClick={selectAuditLog}
          />
        )}
      </main>

      <DiffDrawer auditLog={selectedAuditLog} onClose={() => selectAuditLog(undefined)} />
    </>
  );
};
